<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" data-keyboard="false" data-backdrop="static" v-bind:class="{ 'remove-right-padding': isFullWidthMobile }">
        <div v-bind:class="dialogWidthCss" class="message-detail-dialog-print modal-dialog modal-dialog-scrollable" role="document">
            <div class="modal-success modal-content text-center">
                <!--<div class="modal-header pb-1">
                    <slot name="header">
                    </slot>
                </div>-->
                <div class="modal-body pt-2 px-5">
                    <div class="mb-0 bg-white text-center text-portal-soft-black">
                        <h1 class="display-4 mt-3">
                            <i class="fas fa-check-circle message-sent-icon" aria-label="Message Sent" style="color: #A6CE42;"></i>
                        </h1>
                    </div>
                    <slot v-bind:headerText="headerText" name="headerTextSlot">
                        <p class="lead mt-4">
                            <div class="h5">{{headerText}}</div>
                        </p>
                    </slot>
                    <slot v-bind:subHeaderText="subHeaderText" name="subHeaderTextSlot">
                        <p class="mt-4 h6 fw-400 subheader-text" v-html="subHeaderText"></p>
                        <div v-if="showRedirectLink">
                            <h6>{{redirectLinkLongText}} <a target="_self" :href="redirectLinkUrl">{{redirectLinkText}}</a></h6>
                        </div>
                    </slot> 
                </div>
                <div class="modal-footer1 px-5 pt-2 pb-3 d-print-none justify-content-center">
                    <slot v-bind:buttonText="buttonText" name="footer">
                        <div class="container-fluid pl-0 pl-lg-2 pr-0 pr-lg-2">
                            <div class="row my-3 text-center">
                                <div v-if="(mode == 'RecordSavedAdd')" class="col d-flex flex-column">
                                    <button type="button" @click="$emit('onModalClose', 'RecordSavedAdd')" class="btn btn-primary py-2">{{buttonText}}</button>
                                </div>
                                <div v-if="(mode == 'SuccessMessage')" class="col d-flex flex-column">
                                    <button type="button" @click="$emit('onModalClose', 'RecordSavedAdd')" class="btn btn-primary" style="width:60%">{{buttonText}}</button>
                                </div>
                                <div v-else-if="mode != 'RecordSavedAdd' && mode != 'SuccessMessage'" class="col d-flex flex-column">
                                    <button type="button" @click="$emit('onModalClose', 'RecordSaved')" class="btn btn-primary mx-auto" style="width:60%">{{buttonText}}</button>
                                </div>
                            </div>
                        </div>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        props: {
            mode: { type: String },
            headerText: { type: String }, 
            subHeaderText: { type: String },
            buttonText: { type: String },
            showRedirectLink: { type: Boolean },
            redirectLinkLongText: { type: String },
            redirectLinkText: { type: String },
            redirectLinkUrl: { type: String }
        },
        data: function () {
            return {
                isSuccessMessage: false
            }
        },
        computed: {

            dialogWidthCss: function () {

                return 'modal-xs-100 modal-sm-100 modal-md-75 modal-lg-50 modal-xl-50';
            },

            //bootstrap is sticking padding on when we go xs and sm full width. So we are going to just set it to 0. hack
            isFullWidthMobile: function () {
                return this.dialogWidthCss.indexOf('modal-xs-100') > -1 || this.dialogWidthCss.indexOf('modal-sm-100') > -1;
            }
        }
    };

</script>